var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyOrders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1781_31063)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.2852,
    y: 5,
    width: 6.89586,
    height: 6.89586,
    transform: "rotate(65.7015 13.2852 5)",
    fill: "#EBAB78"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.31836,
    y: 14.8809,
    width: 10,
    height: 12,
    transform: "rotate(-69.0303 8.31836 14.8809)",
    fill: "#EBAB78"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 10,
    width: 10,
    height: 12,
    fill: "#EBAB78"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.187 5L6 7.475L17.25 11.975L23.437 9.5",
    fill: "#EBAB78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.187 5L6 7.475L17.25 11.975L23.437 9.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 7.47461V20.9746L14.4619 24.3594C13.5 20.9746 14.7119 17.6537 17.5 16.4996L17.25 11.9746L6 7.47461Z",
    fill: "#EBAB78",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 11.975L23.437 9.5L17.25 11.975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 11.975L23.437 9.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4375 9.525V16.833",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4375 9.5L12.1875 5L23.4375 9.5Z",
    fill: "#FFE8D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4375 9.5L12.1875 5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2497 12.2246L13.0352 13.3388",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 22,
    r: 6,
    fill: "#EAEAEA",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.652 21.9997H20V19.3477",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1781_31063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 25,
    fill: "white",
    transform: "translate(5 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyOrders);
export default __webpack_public_path__ + "static/media/my-orders.22d3ce6f2c983695edd6291f56961bcb.svg";
export { ForwardRef as ReactComponent };